import axios from 'axios';
import utils from './utils';
import store from '../store';
import router from '../router';

// axios配置
axios.defaults.timeout = 1000000;
// axios.defaults.baseURL = '/proxy_api';
axios.defaults.baseURL = 'https://api.lyszyy.com';
// axios.defaults.baseURL = 'http://192.168.31.128:342/api/';
// 请求拦截器
axios.interceptors.request.use(
  (req) => {
    const a = '3kLN5acX-BfZD70BveYzwHVFKEp1ONzv1_Q4NXM_Ql4';
    req.headers.Authorization = store.state.token || a;
    return req;
  },
  err => Promise.reject(err));
// 响应拦截器
axios.interceptors.response.use(
  res => res,
  (err) => {
    if (err.response.status === 403) {
      utils.deleteCookie('token');
      store.commit('TOKEN', null);
      store.commit('ISLOADING', false);
      router.replace({
        path: '/login',
        query: { redirect: router.currentRoute.fullPath },
      });
    }
    return Promise.reject(err.response.data);
  });
export default axios;



// WEBPACK FOOTER //
// ./src/config/axios.js